import React, { useEffect, useState } from "react";
import ZoneListTab from "./ZoneListTab";
import TireListTab from "./TireListTab";

const ZoneManagement: React.FC = () => {
  const roles = ["Zone", "Tier"];

  const [activeRole, setActiveRole] = useState<string>(
    () => localStorage.getItem("TierActiveRole") || "Tier"
  );
  useEffect(() => {
    localStorage.setItem("TierActiveRole", activeRole);
  }, [activeRole]);

  return (
    <>
      <div className="space-y-4">
        {activeRole === "Zone" && (
          <ZoneListTab
            options={roles}
            active={activeRole}
            onChange={setActiveRole}
          />
        )}
        {activeRole === "Tier" && (
          <TireListTab
            options={roles}
            active={activeRole}
            onChange={setActiveRole}
          />
        )}
      </div>
    </>
  );
};

export default ZoneManagement;
